/* Carosello prodotti nel cart drawer.
   Custom element: si re-inizializza da solo ad ogni re-render del drawer. */
if (!customElements.get('dl-cart-upsell')) {
  customElements.define(
    'dl-cart-upsell',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.source !== 'related') return;
        const productId = this.dataset.productId;
        if (!productId) return;
        fetch(`${this.dataset.url}.json?product_id=${productId}&limit=8&intent=related`)
          .then((r) => (r.ok ? r.json() : { products: [] }))
          .then(({ products }) => {
            if (!products || !products.length) {
              this.style.display = 'none';
              return;
            }
            const money = (cents) =>
              '€' + (cents / 100).toFixed(2).replace('.', ',');
            this.querySelector('.dl-upsell__track').innerHTML = products
              .map(
                (p) => `
                <a class="dl-upsell__card" href="${p.url}">
                  ${p.featured_image ? `<img class="dl-upsell__img" src="${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=220" loading="lazy" alt="">` : ''}
                  <span class="dl-upsell__name">${p.title}</span>
                  <span class="dl-upsell__price">${money(p.price)}</span>
                </a>`
              )
              .join('');
          })
          .catch(() => {
            this.style.display = 'none';
          });
      }
    }
  );
}
